import { ChevronUp, ChevronDown, ChevronsUpDown } from "lucide-react"
import type { ClientTheme } from "@/app/lib/themes"

interface SortIconProps {
  col: string | null
  sortKey: string | null
  sortDir: "asc" | "desc"
  theme: ClientTheme
}

export function SortIcon({ col, sortKey, sortDir, theme }: SortIconProps) {
  if (sortKey !== col) return <ChevronsUpDown size={12} style={{ color: theme.textDim }} />
  return sortDir === "asc" ? (
    <ChevronUp size={12} style={{ color: theme.brandAccent }} />
  ) : (
    <ChevronDown size={12} style={{ color: theme.brandAccent }} />
  )
}
